import {Injectable} from '@angular/core';
import {ConfirmDialogComponent} from "../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {DbModalService} from "../../../modules/modal/modal";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import { BehaviorSubject } from 'rxjs';
import {OneMonthFreeComponent} from "../../../shared/components/dialogs/one-month-free/one-month-free.component";
import {TextUtils} from "../../../shared/utils/text-utils";


@Injectable()
export class AiBuilderCommonService {

  fromAddPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  pageLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    private _dialogService: DialogService,
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _modalService: DbModalService
  ) {
  }

  public handleGenerationExceeded(userSubscription: UserSubscription, fnForAnalytics?: () => void) {
/*    if (userSubscription && userSubscription.type === UserSubscriptionType.FREE) {
      const modal = this._modalService.open(OneMonthFreeComponent, {height: 600, width: 940});
      modal.componentInstance.mode = 'editor';
      return;
    }*/
    if (fnForAnalytics) {
      fnForAnalytics();
    }/*
    this._showExceededDialog(userSubscription);*/
  }

  private _showExceededDialog(userSubscription: UserSubscription): void {
    this._dialogService
      .addDialog(ConfirmDialogComponent, {
        header: TextUtils.getText('text_youExceededTheLimitForAiGenerations'),
        message: userSubscription && userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_upgradeToHigherPlanToGetMoreAiGenerations') : TextUtils.getText('text_youExceededTheLimitForAiGenerationsDesc'),
        confirmButtonText: userSubscription && userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_upgrade') : TextUtils.getText('text_contactUsTitle'),
        confirmButtonClass: 'ds-btn-blue rectangle'
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
        if (userSubscription && userSubscription
            .status === UserSubscriptionStatus.canceled) {
            this._router.navigate(['/workspace/subscription-plan']);
          }
          else if (userSubscription && userSubscription.category === UserSubscriptionCategory.ENTERPRISE) {
            this.openChat();
          } else {
            this._router.navigate(['/upgrade-plan']);
          }
        }
      });
  }

  private openChat() {
    window['zE']('webWidget', 'chat:removeTags', ['generic_support']);
    window['zE']('webWidget', 'chat:addTags', ['open_livechat']);
    window['zE']('webWidget', 'show');
    window['zE']('webWidget', 'open');
    window['zE']('webWidget', 'chat:send', 'Get more AI generations');
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  public checkCanGenerate(userSubs: UserSubscription, count): boolean {
    if (userSubs && userSubs.plan && (count || count === 0)) {
      const fullCount = parseInt(userSubs.plan.services.ai_builder.regeneration_count.parameter_value, 10);
      return count < fullCount;
    }
    return true;
  }

}
